export default __webpack_public_path__ + "static/ResearchUI_Mobile-642e5585f5cebc787ffe796403bc2e9f.png";